// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"8132122d","156":"f65946d4","393":"27f9a8bd","478":"f01077b7","490":"542cc89d","527":"76893ded","569":"677d2dcb","661":"ee741ced","705":"42b7c1f3","746":"fd0504e1","796":"8ec22171","889":"cbf5f04a"}[chunkId] + ".chunk.js";
};